/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddAgentRequest as AgentApiContractAddAgentRequest } from '../../models/AgentApi/Contract/add-agent-request';
import { Agent as AgentApiContractAgent } from '../../models/AgentApi/Contract/agent';

export interface ApiAgentAddAgentPost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AgentApiContractAddAgentRequest
}

export function apiAgentAddAgentPost(http: HttpClient, rootUrl: string, params?: ApiAgentAddAgentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAgent>> {
  const rb = new RequestBuilder(rootUrl, apiAgentAddAgentPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractAgent>;
    })
  );
}

apiAgentAddAgentPost.PATH = '/api/Agent/AddAgent';
